module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens21-cdf8d9754ac286f7c4a56c931b9f833c.jpg";